import React from 'react'
import style from '../card.module.css'

function Himanshi() {
  return (
    <div className={style.review_students}>
        <p>
        I am really glad to become a member of this platform...
        I am really enjoying the classes here... 
        Teacher interaction with us is very good and the method of teaching is also good.. 
        Thnku unacadmey...🥰🥰🥰    
        </p>    
      <div className={style.review_students_name_start}>
          <div>
            <h2>Himanshi Singh</h2>  
            <p>20,932 learning minutes • NDA</p> 
          </div>
          <div>
            <h1>⭐⭐⭐⭐⭐</h1>  
            <p>2 month ago</p> 
          </div>   
      </div>  
    </div>
  )
}

export default Himanshi